import {PayloadAction, createSlice} from '@reduxjs/toolkit';

import {productT} from '@/lib/types/product.types';

interface PRODUCT_STATE {
  products: productT[];
  isLoading: boolean;
  error: string | null;
}

const PRODUCT_INITIAL: PRODUCT_STATE = {
  products: [],
  isLoading: false,
  error: null,
};

const productSlice = createSlice({
  name: 'product',
  initialState: PRODUCT_INITIAL,
  reducers: {
    PRODUCT_UPDATE: (
      state,
      action: PayloadAction<{
        data?: Partial<PRODUCT_STATE>;
        prop?: keyof PRODUCT_STATE;
        value?: any;
      }>
    ) => {
      if (action.payload.data) {
        Object.entries(action.payload.data).forEach(([key, value]) => {
          if (key in state) {
            (state as any)[key] = value;
          }
        });
        return state;
      }

      if (action.payload.prop && action.payload.value !== undefined) {
        const prop = action.payload.prop;

        // Narrow the assignment to only properties that exist on the state
        if (prop in state) {
          (state as any)[prop] = action.payload.value;
        }
      }

      return state;
    },
  },
});

const {PRODUCT_UPDATE} = productSlice.actions;

export {productSlice, PRODUCT_INITIAL, PRODUCT_UPDATE};
